import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    medicamento: [],
  },

  getters: {
    getMedicamento: (state) => state.medicamento,

    getListaMedicamentosControlados: (state) => {
      const listaMedicamentos = [];

      state.medicamento.forEach((medicamento) => {
        listaMedicamentos.push({
          fk_idCatMedicamento: medicamento.id,
          medicamento: medicamento.title,
          receto: '',
          tieneReceta: false,
          fechaInicio: null,
          lugarConsiguio: '',
          dosisDetalle: '',
          detalle: '',
        });
      });

      return listaMedicamentos;
    },

    getListaMedicamentosActuales: (state) => {
      const listaMedicamentosActuales = [];

      state.medicamento.forEach((medicamento) => {
        listaMedicamentosActuales.push({
          fk_idCatMedicamento: medicamento.id,
          medicamento: medicamento.title,
          fechaInicio: null,
          fechaFinal: null,
          fechaInicioFin: null,
          diagnosticoTratamiento: '',
        });
      });

      return listaMedicamentosActuales;
    },
  },

  mutations: {
    SET_MEDICAMENTO(state, medicamento) {
      state.medicamento = medicamento;
    },
  },

  actions: {
    async fetchMedicamento({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catMedicamento')
        .then((response) => {
          commit('SET_MEDICAMENTO', response.data.data);
        });
    },
  },
};
